import * as React from 'react'
import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'

import * as duvet from '@ulule/duvet'
import * as env from '@owl-nest/config'
import * as models from '@owl-nest/models'
import { useTracking } from '@owl-nest/shadow'

import { SIDEBAR_MAX_WIDTH } from '../../style'

type BaseRewardProps = {
  className?: string
  disabled?: boolean
  reward: models.reward.Reward
  onClick: (id: number, optionValuesIds?: string[]) => void
  trackView?: boolean
}

export function BaseReward({
  className,
  disabled = false,
  reward,
  onClick,
  trackView,
}: BaseRewardProps): React.ReactElement<BaseRewardProps> {
  const userConfig = env.useUserEnv()

  const tracking = useTracking()
  const { ref, inView } = useInView({
    triggerOnce: true,
  })

  React.useEffect(() => {
    if (inView && trackView) {
      tracking.ecommerce.track('view_item', {
        items: [
          {
            item_id: String(reward.id),
            item_name: models.reward.title(reward) ?? '',
            item_brand: models.project.name(reward.project),
            price: reward.price,
          },
        ],
      })
    }
  }, [inView])

  return (
    // HACK: This wrapper is only here to avoid using forwardRef. When moving to
    //  React 19, please remove it and pass `className` and `ref` as props.
    //  Come on, don't pretend you didn't see this comment, telling yourself
    //  someone else will do it later. Be that person, now is the time to shine.
    //  Thank you!
    <InViewDetector className={className} ref={ref}>
      <duvet.rewardCard.RewardCard
        disabled={disabled}
        reward={reward}
        fullWidth={true}
        onSelect={{
          reward: () => {
            onClick(reward.id)
          },
          variant: (id, optionValuesIds) => {
            id && onClick(Number(id), optionValuesIds)
          },
        }}
      />
    </InViewDetector>
  )
}

const InViewDetector = styled.div`
  max-width: ${SIDEBAR_MAX_WIDTH};
`
